import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {FormRadioButtonsComponent} from './form-radio-buttons.component';
import {SharedModule} from '../../../modules/shared/shared.module';
import {FormInputErrorModule} from '../form-input-error/form-input-error.module';
import {SelectButtonModule} from 'primeng/selectbutton';
import {ReactiveFormsModule} from '@angular/forms';

@NgModule({
  declarations: [
    FormRadioButtonsComponent
  ],
  exports: [
    FormRadioButtonsComponent
  ],
  imports: [
    CommonModule,
    SharedModule,
    FormInputErrorModule,
    SelectButtonModule,
    ReactiveFormsModule
  ]
})
export class FormRadioButtonsModule {
}
